import debounce from 'lodash.debounce';
import Cookies from 'js-cookie';
import * as bootstrap from 'bootstrap';
import jsKit from './modules/jsKit';
import { swipers } from './modules/swipers';
import kitman from './modules/kitman';
import topLoader from '../../shared/modules/topLoader';
import basket from './modules/basket';
import basketPlugins from '../../shared/modules/basketPlugins';
import initProductListEndlessScroll from './modules/sndlessScroll';
import { RippleEffect } from '../../shared/modules/ripple';
import cookiesSettings from '../../shared/modules/cookiesSettings';
import showExpertContact from './modules/showExpertContact';
import currency from './modules/currency';
import { initPopupBanners } from '../../shared/modules/popupBanners';
import { headerSpecialFunctionsEvents } from '../../shared/modules/headerSpecialFunctions';
import { initFlashMessages } from '../../shared/modules/flashMessages';
import { initOrderStatus } from '../../shared/modules/orderStatus';
import { ceneoOrderEvents, initCeneoOrder } from '../../shared/modules/ceneoOrder';
import { infoBarEvents } from '../../shared/modules/infoBar';
import { initOAuth } from '../../shared/modules/oAuth';
import { initGlobalBootstrapComponents } from '../../shared/modules/bootstrapComponents';
import { initModalAutofocus, initPopupContainerCleanup } from '../../shared/modules/modalLifecycle';

window.showNotificationsPanel = jsKit.showNotificationsPanel;
initOAuth();
basketPlugins.configure({ jsKit, bootstrap });

const kitmanEvents = [
  ['jsKitmanSetDelete', (e) => kitman.kitmanSetDelete(e)],
  ['jsChangeCurrency', (e) => currency.changeCurrency(e), 'change'],
  ...headerSpecialFunctionsEvents,
  ...infoBarEvents,
  ...ceneoOrderEvents,
  ['ga4EventClick', (e) => kitman.GA4Event(e)],
  ['ga4EventChange', (e) => kitman.GA4Event(e), 'change'],

  ['jsShowMovie', (e) => kitman.showMovie(e)],
  ['jsShowOfferInfo', (e) => kitman.showOfferInfo(e)],
  ['jsGhostParams', (e) => kitman.selectGhost(e)],

  ['jsProductSelectClick', (e) => kitman.selectProduct(e)],
  ['jsProductSelectChange', (e) => kitman.selectProduct(e), 'change'],
  ['jsTrigerProductSelect', (e) => kitman.selectProduct(e)],
  ['jsTrigerProductSelect', (e) => kitman.trigerProductSelect(e)],
  ['jsProductId', (e) => kitman.showKitbuilderProduct(e)],
  ['jsClearSlot', (e) => kitman.clearSlot(e)],
  ['jsSelectFiltersOptionSize', (e) => kitman.selectFiltersOptionSize(e.target.dataset.jsSelectFiltersOptionSize), 'change'],
  ['jsChangeFiltersOptionSize', (e) => kitman.changeFiltersOptionSize(e), 'input'],
  ['jsSelectFiltersOption', (e) => kitman.selectFiltersOption(e), 'change'],
  ['jsSelectSortingOption', (e) => kitman.jsSelectSortingOption(e), 'change'],
  ['jsSelectPriceRange', debounce(kitman.selectPriceRange, 1200), 'input'],
  ['jsClearFilters', kitman.clearFilters],
  ['jsSelectSearchPhrase', debounce(kitman.selectSearchPhrase, 1000), 'input'],
  ['jsSelectClickable', (e) => kitman.selectClickable(e.target.dataset.jsSelectClickable)],
  ['jsSaveKitbuilderSet', (e) => kitman.saveKitbuilderSet(e)],

  ['jsSaveKitbuilderSlotInput', debounce(kitman.saveKitbuilderSlot, 1000), 'input'],
  ['jsSaveKitbuilderSlotChange', (e) => kitman.saveKitbuilderSlot(e), 'change'],
  ['jsSaveKitbuilderSlotClick', (e) => kitman.saveKitbuilderSlot(e), 'click'],
  ['jsSaveKitbuilderSlotRadioControl', (e) => kitman.saveKitbuilderSlotRadioControl(e)],
  ['jsSelectClickable3', (e) => kitman.selectClickable3(e.target.dataset.jsSelectClickable3)],
  ['jsSlotParams', (e) => kitman.loadKitbuilderSlot(...e.target.dataset.jsSlotParams.split(', '))],

  ['jsSaveKitbuilderSlotItemSettingsInput', debounce((e) => kitman.saveKitbuilderSlotItemSettings(e), 1000), 'input'],
  ['jsSaveKitbuilderSlotItemSettingsChange', (e) => kitman.saveKitbuilderSlotItemSettings(e), 'change'],
  ['jsSetNoLogin', (e) => kitman.setNoLogin(e)],
  ['jsSaveKitbuilderSlotItemInput', debounce(kitman.saveKitbuilderSlotItem, 1000), 'input'],
  ['jsSaveKitbuilderSlotItemChange', (e) => kitman.saveKitbuilderSlotItem(e), 'change'],
  ['jsSaveKitbuilderSlotItemClick', (e) => kitman.saveKitbuilderSlotItem(e), 'click'],
  ['jsShowProductSizes', (e) => kitman.showProductSizes(e)],

  ['jsClearClickable', (e) => kitman.clearClickable(e)],
  ['jsValidateKitbuilderStep', (e) => kitman.validateKitbuilderStep(e)],
  ['jsGhostView', (e) => kitman.loadGhostView(e)],
  ['jsLoadKitbuilderStep', (e) => kitman.loadKitbuilderStep(e)],
  ['jsEnlargeProduct', (e) => kitman.enlargeProduct(e)],
  ['jsSlotItemParams', (e) => kitman.loadKitbuilderSlotItem(...e.target.dataset.jsSlotItemParams.split(', '))],
  ['jsClearSlotItem', (e) => kitman.clearSlotItem(e)],

  ['jsGraphicFileUpload', kitman.uploadKitbuilderGraphicFile, 'change'],
  ['jsShowSettings', (e) => kitman.showSettings(e)],
  ['jsShowLoginForm', (e) => kitman.showLoginForm(e)],
  ['jsShowRegisterForm', (e) => kitman.showRegisterForm(e)],
  ['jsLogoutClientKitman', (e) => kitman.logoutClientKitman(e)],
  ['jsKitmanPasswordReset', (e) => kitman.kitmanPasswordReset(e)],
  ['jsKitmanPasswordForgot', (e) => kitman.kitmanPasswordForgot(e)],
  ['jsShowPasswordForgotForm', (e) => kitman.showPasswordForgotForm(e)],
  ['jsAddOutfit', kitman.addOutfit],
  ['jsLoginClientKitman', (e) => kitman.loginClientKitman(e)],
  ['jsClientRegisterKitman', (e) => kitman.clientRegisterKitman(e)],
  ['jsRenameSet', debounce(kitman.renameSet, 1000), 'input'],
  ['jsRenameOutfitInput', debounce((e) => kitman.renameOutfit(e), 1000), 'input'],
  ['jsSelectOutfit', (e) => kitman.selectOutfit(e)],
  ['jsRemoveOutfit', (e) => kitman.removeOutfit(e)],
  ['jsSettingsRemoveOutfit', (e) => kitman.settingsRemoveOutfit(e)],
  ['jsSettingsClearClickable', (e) => kitman.settingsClearClickable(e)],
  ['jsAddLoader', (e) => kitman.addLoader(e)],
  ['jsFillClickable', (e) => kitman.fillClickable(e)],
  ['jsSelectProductOptionChange', (e) => kitman.selectProductOption(e), 'change'],
  ['jsSelectProductOptionSettingsChange', (e) => kitman.selectProductOptionSettings(e), 'change'],
  ['jsSelectClickable4', (e) => kitman.selectClickable4(e)],
  ['jsRemoveFilterSelected', (e) => kitman.removeFilterSelected(e)],

  ['jsAddSetToKitmanBasket', (e) => kitman.addSetToKitmanBasket(e)],
  ['jsClearSearchPhrase', kitman.clearSearchPhrase],
  ['jsClearPriceInputParam', kitman.clearPriceInputParam],
  ['jsSettingsAddOutfit', kitman.settingsAddOutfit],
  ['jsForceAddSetToKitmanBasket', kitman.forceAddSetToKitmanBasket],
  ['jsToggleSideMenu', (e) => kitman.toggleSideMenu(e.target.dataset.jsToggleSideMenu)],
  ['jsCloseDiscountCouponPanel', kitman.closeDiscountCouponPanel],
  ['jsCheckDiscountCoupon', (e) => kitman.checkDiscountCoupon(e)],
  ['jsLoadDiscountCouponPanel', (e) => kitman.loadDiscountCouponPanel(e)],
  ['jsRemoveDiscountCoupon', (e) => kitman.removeDiscountCoupon(e)],
  ['jsClearSlotInOutfitsInKitmanBasket', (e) => kitman.clearSlotInOutfitsInKitmanBasket(e)],
  ['jsRemoveSetFromKitmanBasket', (e) => kitman.removeSetFromKitmanBasket(e)],
  ['jsEditSetFromKitmanBasket', (e) => kitman.editSetFromKitmanBasket(e)],
  ['jsEditCurrentSetFromKitmanBasket', (e) => kitman.editSetCurrentFromKitmanBasket(e)],
  ['jsEditKitbuilderSet', (e) => kitman.editKitbuilderSet(e)],
  ['jsShowInfo', (e) => kitman.showInfo(e)],
  ['jsChangeDeliveryPriceListCountry', kitman.changeDeliveryPriceListCountry, 'change'],
  ['jsShowDeliveryPriceLists', (e) => kitman.showDeliveryPriceLists(e)],

  ['jsBasketSummary', (e) => basket.basketSummary(e)],
  ['jsShowDeliveryOptionPanel', (e) => basketPlugins.showDeliveryOptionPanel(e)],
  ['jsSetDeliveryOption', (e) => basket.setDeliveryOption(e), 'change'],
  ['jsFindInpostMachines', (e) => basketPlugins.findInpostMachines(e)],
  ['jsSelectInPostOption', (e) => basketPlugins.selectInPostOption(e)],
  ['jsShowPaymentOptionPanel', () => basketPlugins.showPaymentOptionPanel()],
  ['jsSetPaymentOption', (e) => basket.setPaymentOption(e), 'change'],
  ['jsChangeDeliveryCountry', (e) => basket.changeDeliveryCountry(e), 'change'],
  ['jsToggleInvoiceData', (e) => basket.toggleInvoiceData(e), 'change'],
  ['jsCopyDeliveryDataToInvoiceData', (e) => basket.copyDeliveryDataToInvoiceData(e)],
  ['jsCreateOrderKitman', (e) => basket.createOrderKitman(e)],
  ['jsShowDeliveryPluginOptions', () => basketPlugins.showDeliveryOptionPanel(null, true), 'DOMContentLoaded'],
  ['jsShowPaymentPluginOptions', () => basketPlugins.showPaymentOptionPanel(), 'DOMContentLoaded'],
  ['jsCreatePayment', (e) => {
    e.preventDefault();
    basketPlugins.createPayment(e.delegateTarget.dataset.jsCreatePayment);
  }],
  ['jsFinalizePayment', (e) => {
    e.preventDefault();
    basketPlugins.finalizePayment();
  }],
  ['jsFinalizePaymentCountdown', () => basketPlugins.finalizePaymentCountdown(), 'DOMContentLoaded'],
  ['jsShowPasswordResetModal', () => kitman.showPasswordResetModal(), 'DOMContentLoaded'],
  ['jsResetPasswordSuccess', () => kitman.resetPasswordSuccess(), 'DOMContentLoaded'],
  ['jsPattern', (e) => kitman.inputPattern(e), 'input'],
];

const registerKitmanEvents = () => {
  kitmanEvents.forEach(([dataItem, handler, eventName]) => {
    jsKit.attachEventByDataSet(dataItem, handler, eventName);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // init swipers
  swipers.initPlayersSwiper();
  swipers.initOutfitsOfferSwiper();
  swipers.initPOKOurClientsSwiper();
  swipers.initPOKCataloguesSwiper();
  swipers.initPOKTrustedUsSwiper();
  swipers.initPOKStatisticsSwiper();
  swipers.initPrintZoneSwiper();
  swipers.initOutfitsListSwiper();
  swipers.initFeaturesSwiper();
  swipers.initFullPageSwiper();
  swipers.initOutfitsSwiper();
  swipers.initTrustedUsSwiper();
  kitman.setPriceCheckboxState();
  cookiesSettings(bootstrap);
  kitman.GA4Event();
  topLoader();
  initPopupBanners();
  initFlashMessages();
  initOrderStatus();
  initCeneoOrder();

  if (Cookies.get('_cookieSettingsRequired')) {
    setTimeout(() => Cookies.set('_wasWelcomed', 1, { expires: 30 }), 3000);
    if (Cookies.get('_wasWelcomed') && Cookies.get('_modalBannerWasShowed') !== '1') {
      jsKit.showModal('#modal_banner');
      Cookies.set('_modalBannerWasShowed', 1, { expires: 5 });
    }
  }

  if (showExpertContact.checkDate() && document.documentElement.lang === 'pl' && document.querySelector('#expert')) {
    document.querySelector('#expert').classList.remove('d-none');
  }

  // endless scroll form product list in STEP 2
  initProductListEndlessScroll();

  initGlobalBootstrapComponents();
  initPopupContainerCleanup();
  initModalAutofocus();

  registerKitmanEvents();
}, false);
